export default __webpack_public_path__ + "static/media/cookie-icon.6d495a71.svg";